<template>
  <section class="channel-type-workspace">
    <table-toolbar
      :search.sync="search"
      :show-search="true"
      :show-refresh="true"
      :show-export="true"
      :show-column-settings="true"
      :columns="columnConfigOptions"
      :visible-columns.sync="visibleColumns"
      :default-columns="defaultColumnsList"
      :fixed-columns="['# ID', '类型名称', '操作']"
      :min-selected="4"
      search-placeholder="输入关键字搜索渠道类型..."
      export-confirm-title="确定要导出当前筛选后的渠道类型数据吗？"
      @refresh="handleReset"
      @export="handleExport"
    >
      <template slot="left">
        <el-button type="primary" size="small" icon="el-icon-plus" class="btn-action" @click="handleAddChannelType">新增渠道类型</el-button>

        <el-select
          v-model="packageType"
          size="small"
          placeholder="选择包类型"
          clearable
          class="filter-select"
          @change="packageTypeChange"
        >
          <el-option value="" label="全部类型"></el-option>
          <el-option v-for="item in packageTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </template>
    </table-toolbar>

    <table-page
      :loading="loading"
      :empty="tables.length === 0"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :total="totalCount"
      :page-sizes="[10, 20, 30, 50, 100, 200]"
      :show-top-pagination="!!totalCount"
      :show-bottom-pagination="!!totalCount"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      @retry="handleReset"
    >
      <el-table :data="tables" stripe style="width: 100%" class="premium-table">
        <el-table-column key="col-id" prop="id" width="150">
          <template slot="header">
            <span class="premium-header-title"><span class="header-icon-hash">#</span> ID</span>
          </template>
          <template slot-scope="scope">
            <span class="cell-id">{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column key="col-name" prop="name" min-width="180">
          <template slot="header">
            <span class="premium-header-title">类型名称</span>
          </template>
          <template slot-scope="scope">
            <el-link type="primary" class="cell-name-link" @click="handleUpdateChannelType(scope.$index, scope.row)">
              {{ scope.row.name }}
            </el-link>
          </template>
        </el-table-column>

        <el-table-column v-if="visibleColumns.includes('packageType')" key="col-packageType" prop="packageType" min-width="150">
          <template slot="header">
            <span class="premium-header-title">包类型</span>
          </template>
          <template slot-scope="scope">
            <el-tag
              :class="['package-type-tag', getPackageTypeTagType(scope.row.packageType) === 'purple' ? 'el-tag--purple' : '']"
              :type="getPackageTypeTagType(scope.row.packageType) === 'purple' ? 'info' : getPackageTypeTagType(scope.row.packageType)"
              size="small"
            >
              {{ getPackageTypeLabel(scope.row.packageType) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column key="col-actions" width="86" align="center">
          <template slot="header">
            <span class="premium-header-title">操作</span>
          </template>
          <template slot-scope="scope">
            <el-dropdown @command="handleActionCommand($event, scope.row, scope.$index)" trigger="hover">
              <el-button size="mini" class="action-btn" circle icon="el-icon-more-outline"></el-button>
              <el-dropdown-menu slot="dropdown" class="premium-dropdown-menu">
                <el-dropdown-item command="edit">
                  <i class="el-icon-edit"></i> 编辑类型
                </el-dropdown-item>
                <el-dropdown-item command="delete" class="dropdown-danger">
                  <i class="el-icon-delete"></i> 删除类型
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </table-page>

    <el-drawer
      :visible.sync="dialogVisible"
      direction="rtl"
      :size="drawerSize"
      destroy-on-close
      :before-close="handleDrawerBeforeClose"
      custom-class="standard-form-drawer"
      :with-header="false"
    >
      <div class="detail-workspace">
        <div class="breadcrumb-header">
          <div class="header-top-row">
            <div class="header-left">
              <span class="header-title">
                <span class="header-title-icon"><i :class="type ? 'el-icon-edit-outline' : 'el-icon-plus'"></i></span>
                {{ type ? `编辑：${form.id} - ${form.name || ''}` : '新增渠道类型' }}
              </span>
            </div>
            <div class="header-right-buttons">
              <el-button size="small" @click="handleCloseDialog"><i class="el-icon-back"></i> 返回列表</el-button>
              <el-button type="success" size="small" :loading="saveLoading" :disabled="saveLoading" @click="handleSaveDialog">保存</el-button>
            </div>
          </div>
        </div>

        <div class="detail-content">
          <el-form :model="form" label-position="right" label-width="140px" size="small" :rules="rules" ref="form" class="form-container">
            <el-form-item label="包类型" prop="packageType">
              <el-select v-model.trim="form.packageType" filterable placeholder="请选择包类型" style="width: 100%">
                <el-option v-for="item in packageTypes" :key="item.value" :label="item.value + ' - ' + item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Type ID" prop="id">
              <el-input v-model.number="form.id" placeholder="请输入渠道类型 ID"></el-input>
            </el-form-item>
            <el-form-item label="类型名称" prop="name">
              <el-input v-model.trim="form.name" placeholder="请输入渠道类型名称"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-drawer>
  </section>
</template>

<script>
import api from '@/api/channel'
import options from '@/common/options'
import * as XLSX from 'xlsx'
import TablePage from '@/components/TablePage/index.vue'
import TableToolbar from '@/components/TableToolbar/index.vue'

export default {
  name: 'index',
  components: { TablePage, TableToolbar },
  created () {
    this.fetchData(this.pageSize, this.currentPage)
  },
  computed: {
    appId () {
      return this.$store.getters.appId
    },
    tables () {
      const search = this.search
      if (search) {
        return this.tableData.filter(data => {
          return Object.keys(data).some(key => {
            return String(data[key]).toLowerCase().indexOf(search.toLowerCase()) > -1
          })
        })
      }
      return this.tableData
    },
    drawerSize () {
      if (this.viewportWidth <= 768) return '100%'
      if (this.viewportWidth <= 1200) return '72%'
      return '50%'
    },
    columnConfigOptions () {
      return this.allConfigurableColumns.map(item => ({
        prop: item.value,
        label: item.label
      }))
    }
  },
  watch: {
    appId (val, oldVal) {
      if (val === oldVal) {
        return
      }
      this.fetchData(this.pageSize, this.currentPage)
    }
  },
  data () {
    const TypeValidator = (rule, value, callback) => {
      const packageType = Number(this.form.packageType)
      if (!packageType) {
        callback(new Error('请先选择包类型！'))
        return
      }
      if (value === '') {
        callback(new Error('请输入 Type'))
      } else if (typeof (value) !== 'number') {
        callback(new Error('请输入数字'))
      } else if (value < 0) {
        callback(new Error('请输入有效数字'))
      } else if (value >= (packageType + 1) * 1000) {
        callback(new Error('Type 应小于' + (packageType + 1) * 1000))
      } else if (value <= packageType * 1000) {
        callback(new Error('Type 应大于' + packageType * 1000))
      } else {
        callback()
      }
    }
    return {
      viewportWidth: window.innerWidth,
      loading: false,
      saveLoading: false,
      pageSize: 20,
      currentPage: 1,
      totalCount: 0,
      tableData: [],
      dialogVisible: false,
      packageType: '',
      packageTypes: options.packageTypes,
      search: '',
      visibleColumns: ['packageType'],
      defaultColumnsList: ['packageType'],
      allConfigurableColumns: [
        { value: 'packageType', label: '包类型' }
      ],
      form: {},
      type: false,
      index: 0,
      rules: {
        packageType: [{ type: 'number', required: true, message: '请选择包类型', trigger: 'change' }],
        id: [{ type: 'number', required: true, validator: TypeValidator, trigger: 'blur' }],
        name: [{ type: 'string', required: true, message: '请输入名称', trigger: 'blur' }]
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.viewportWidth = window.innerWidth
    },
    fetchData (pageSize, currentPage) {
      this.loading = true
      const params = {
        size: pageSize,
        page: currentPage
      }
      if (this.packageType) {
        params.packageType = this.packageType
      }
      api.getChannelTypeDataByPage(params).then(res => {
        this.tableData = res.data
        this.totalCount = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchData(val, this.currentPage)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData(this.pageSize, val)
    },
    packageTypeChange (val) {
      this.packageType = val
      this.currentPage = 1
      this.fetchData(this.pageSize, this.currentPage)
    },
    handleReset () {
      this.fetchData(this.pageSize, this.currentPage)
    },
    handleExport () {
      if (!this.tables || this.tables.length === 0) {
        this.$message.warning('当前暂无可导出的渠道类型数据')
        return
      }
      const exportData = this.tables.map(row => {
        return {
          ChannelTypeID: row.id,
          类型名称: row.name,
          包类型: this.getPackageTypeLabel(row.packageType)
        }
      })
      const workbook = XLSX.utils.book_new()
      const worksheet = XLSX.utils.json_to_sheet(exportData)
      XLSX.utils.book_append_sheet(workbook, worksheet, '渠道类型')
      XLSX.writeFile(workbook, `渠道类型-${new Date().getTime()}.xlsx`)
      this.$message.success('数据导出成功')
    },
    handleAddChannelType () {
      this.type = false
      this.form = {}
      this.dialogVisible = true
    },
    handleUpdateChannelType (index, rowData) {
      this.type = true
      this.index = index
      this.form = Object.assign({}, rowData)
      this.dialogVisible = true
    },
    handleSaveDialog () {
      if (this.saveLoading) return
      this.$refs.form.validate((valid) => {
        if (!valid) return false
        this.saveLoading = true
        const params = Object.assign({}, this.form)
        const f = this.type ? api.updateChannelType : api.addChannelType
        f(params).then(res => {
          if (this.type) {
            this.tableData.splice(this.index, 1, res)
          } else {
            this.tableData.push(res)
          }
          this.$message.success(this.type ? '修改成功' : '添加成功')
          this.dialogVisible = false
        }).finally(() => {
          this.saveLoading = false
        })
      })
    },
    handleDeletechannelType (id, i) {
      this.$confirm('确定删除吗?', '提示', { type: 'warning' }).then(() => {
        api.deleteChannelType(id).then(() => {
          this.tableData.splice(i, 1)
          this.$message.success('删除成功')
        })
      })
    },
    handleCloseDialog () {
      this.dialogVisible = false
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    handleDrawerBeforeClose (done) {
      this.handleCloseDialog()
      done()
    },
    handleActionCommand (command, row, index) {
      if (command === 'edit') {
        this.handleUpdateChannelType(index, row)
      } else if (command === 'delete') {
        this.handleDeletechannelType(row.id, index)
      }
    },
    getPackageTypeLabel (type) {
      const found = this.packageTypes.find(item => Number(item.value) === Number(type))
      return found ? found.label : type
    },
    getPackageTypeTagType (type) {
      const map = {
        1: '',
        2: 'purple',
        3: 'success',
        4: 'warning',
        5: 'danger'
      }
      return map[type] || 'info'
    }
  }
}
</script>

<style scoped>
.channel-type-workspace {
  padding: 16px 24px;
}

.btn-action {
  height: 32px;
  padding: 0 16px;
  flex-shrink: 0;
  border-color: var(--primary-color) !important;
  border-radius: 8px !important;
  background-color: var(--primary-color) !important;
  font-weight: 600 !important;
}

.btn-action:hover {
  border-color: var(--primary-hover) !important;
  background-color: var(--primary-hover) !important;
}

.filter-select {
  width: 160px;
  flex-shrink: 0;
}

.filter-select :deep(.el-input__inner) {
  height: 32px;
  border-color: #e2e8f0;
  border-radius: 8px;
  background-color: #ffffff;
  color: var(--text-main);
  font-weight: 500;
  line-height: 32px;
}

.filter-select :deep(.el-input__inner:focus) {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

.premium-table {
  border-radius: 8px;
  overflow: hidden;
  border: none !important;
  font-size: 13px !important;
  color: var(--text-main) !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif !important;
}

.premium-table::before {
  display: none !important;
}

.premium-table :deep(.el-table__header-wrapper) th,
.premium-table :deep(.el-table__fixed-header-wrapper) th,
.premium-table :deep(.el-table__fixed-right-header-wrapper) th,
.premium-table :deep(th.el-table__fixed-column) {
  background-color: var(--bg-page) !important;
  color: var(--text-muted) !important;
  font-weight: 700 !important;
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-color) !important;
}

.premium-table :deep(.el-table__row) td {
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-light) !important;
}

.premium-table :deep(.el-table__row) {
  transition: background-color 0.2s ease;
}

.premium-table :deep(.el-table__row:hover) td {
  background-color: var(--bg-hover) !important;
}

.premium-table :deep(.el-table__body tr.hover-row > td),
.premium-table :deep(.el-table__body tr.hover-row.current-row > td),
.premium-table :deep(.el-table__body tr.hover-row.el-table__row--striped > td) {
  background-color: var(--bg-hover) !important;
}

.premium-header-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  color: inherit;
}

.header-icon-hash {
  font-family: Menlo, Monaco, Consolas, monospace;
  font-size: 13.5px;
  font-weight: 900;
  color: inherit;
}

.cell-id {
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace !important;
  font-size: 12.5px !important;
  font-weight: 600;
  color: var(--text-muted);
}

.cell-name-link {
  font-size: 13.5px !important;
  font-weight: 700 !important;
  text-decoration: none !important;
}

.action-btn {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #64748b;
}

.action-btn:hover {
  border-color: #cbd5e1;
  background: #f1f5f9;
  color: var(--text-main);
}

.dropdown-danger,
.dropdown-danger i {
  color: #ef4444 !important;
}

.detail-workspace {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  background-color: #f8fafc;
}

.breadcrumb-header {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 12px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
}

.header-top-row,
.header-left,
.header-right-buttons,
.header-title {
  display: flex;
  align-items: center;
}

.header-top-row {
  width: 100%;
  justify-content: space-between;
  gap: 16px;
}

.header-left {
  min-width: 0;
  gap: 12px;
}

.header-right-buttons {
  flex-shrink: 0;
  gap: 8px;
  margin-left: auto;
}

.header-title {
  min-width: 0;
  gap: 8px;
  color: #1e293b;
  font-size: 15px;
  font-weight: 700;
  white-space: nowrap;
}

.header-title-icon {
  width: 26px;
  height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: rgba(37, 99, 235, 0.08);
  color: var(--primary-color);
}

.detail-content {
  flex: 1;
  overflow-y: auto;
  margin: 12px;
  padding: 18px 20px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.form-container {
  width: 100%;
}

.form-container :deep(.el-form-item) {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.form-container :deep(.el-form-item__label) {
  width: 25% !important;
  min-width: 112px;
  max-width: 180px;
  flex: 0 0 25%;
  padding-right: 12px;
  color: #475569;
  font-weight: 600;
  line-height: 32px;
  text-align: left;
}

.form-container :deep(.el-form-item__content) {
  min-width: 0;
  flex: 1 1 75%;
  margin-left: 0 !important;
}

.form-container :deep(.el-select) {
  width: 100%;
}

.package-type-tag {
  min-width: 72px;
  text-align: center;
  border-radius: 6px;
  font-weight: 600;
}

.package-type-tag.el-tag--purple {
  color: #7c3aed;
  background-color: #f5f3ff;
  border-color: #ddd6fe;
}

/* 深色模式适配 */
html.dark .package-type-tag.el-tag--purple {
  color: #a78bfa !important;
  background-color: rgba(124, 58, 237, 0.15) !important;
  border-color: rgba(124, 58, 237, 0.3) !important;
}

html.dark .package-type-tag.el-tag--success {
  color: #34d399 !important;
  background-color: rgba(16, 185, 129, 0.15) !important;
  border-color: rgba(16, 185, 129, 0.3) !important;
}

html.dark .package-type-tag.el-tag--warning {
  color: #fbbf24 !important;
  background-color: rgba(245, 158, 11, 0.15) !important;
  border-color: rgba(245, 158, 11, 0.3) !important;
}

html.dark .package-type-tag.el-tag--danger {
  color: #f87171 !important;
  background-color: rgba(239, 68, 68, 0.15) !important;
  border-color: rgba(239, 68, 68, 0.3) !important;
}

html.dark .package-type-tag.el-tag--info {
  color: #94a3b8 !important;
  background-color: rgba(148, 163, 184, 0.15) !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}

html.dark .detail-workspace {
  background-color: var(--bg-page) !important;
}

html.dark .breadcrumb-header {
  background-color: var(--bg-card) !important;
  border-bottom-color: var(--border-color) !important;
}

html.dark .breadcrumb-header .header-title {
  color: var(--text-main) !important;
}

html.dark .detail-content {
  background-color: var(--bg-card) !important;
  border-color: var(--border-color) !important;
  box-shadow: none !important;
}

html.dark .form-container :deep(.el-form-item__label) {
  color: var(--text-muted) !important;
}

@media (max-width: 1200px) {
  .channel-type-workspace {
    padding: 16px;
  }
}

@media (max-width: 768px) {
  .breadcrumb-header {
    padding: 12px 16px;
  }

  .header-top-row,
  .header-left {
    align-items: flex-start;
    flex-direction: column;
  }

  .form-container :deep(.el-form-item) {
    display: block;
  }

  .form-container :deep(.el-form-item__label) {
    width: 100% !important;
    max-width: none;
    padding-right: 0;
  }
}
</style>
